// @flow

import Configuration from "../Configuration";
import {dealerShopUrl, hostedDealerHref} from "../preview/helper/hostedRouting";

class RedirectService {
	baseUrl = Configuration.value("redirectServiceUrl");

	// the dealer's hosted shop: /<language>/<brand>/<dealerId>, keeping the visitor's query
	enableDealer = (dealerId: string) => {
		window.location.href = hostedDealerHref(dealerId) + window.location.search;
	};

	// the dealer's own shop page in the dealer's shop routing; the hosted shop as fallback
	enableUrl = (baseUrl: string = "", dealerId: ?string = null, brand: ?string = "", routing: ?string = null) => {
		try {
			window.location.href = dealerShopUrl(baseUrl, routing, brand);
		} catch (e) {
			// baseUrl not valid
			this.enableDealer(dealerId);
		}
	};
}

export default RedirectService;
